import { ContentBlock } from "../models/ArticleModel";
import { ContentModel } from "../models/ContentModel";

export const getColumnNum = (flg: "one" | "two" | "three" | "four") => {
  switch (flg) {
    case "four":
      return 4;
    case "three":
      return 3;
    case "two":
      return 2;
    default:
      return 1;
  }
};

export const convertLines = (
  contents: (ContentModel | null)[],
  column: number
) => {
  const copy = contents.concat();

  const lines = [];
  let current: (ContentModel | null)[] = [];
  while (copy.length > 0) {
    const item = copy.shift();
    if (!item) {
      continue;
    }
    if (item.type === "text") {
      if (current.length > 0) {
        while (current.length < column) {
          current.push(null);
        }
        lines.push(current);
      }
      lines.push([item]);
      current = [];
    } else {
      current.push(item);
      if (current.length >= column) {
        lines.push(current);
        current = [];
      }
    }
  }
  if (current.length > 0) {
    while (current.length < column) {
      current.push(null);
    }
    lines.push(current);
  }
  return lines;
};

export const getPictures = (blocks: ContentBlock[]) => {
  const arr = [];
  for (const block of blocks) {
    for (const content of block.contents) {
      if (content.type === "picture") {
        const org = content.picture.localFile.childImageSharp.fluid;
        arr.push(org.originalImg);
      }
    }
  }
  return arr;
};

export function replaceLink(str: string) {
  return str.replace(
    /(https?:\/\/[a-zA-Z0-9;\/?:@&=\+$,\-_\.!~*'\(\)%#]+)/g,
    '<a href="$1" target="_blank">$1</a>'
  );
}
/** 元記事から詳細記事へのリンクを生成します。
 * ( [[detail]] のテキストを変換 ） */
export function replaceLinkToDetail(text: string) {
  const m = location.href.match(/^.+\/work\/([^/]+)$/);
  if(m) {
    // const key = m[1];
    const to = location.href.replace('work', 'work/detail');
    const label = process.env.GATSBY_LANG === 'EN' ? 'Learn more about the Project' : 'プロジェクトをもっとよく知る'
    return text.replaceAll("[[detail]]", `<a href="${to}">${label}</a>`)
  } else {
    return text.replaceAll("[[detail]]", '')
  }
}
/** 詳細記事から元記事へのリンクを生成します。
 * ( [[parent]] のテキストを変換 ） */
export function replaceLinkToParent(text: string) {
  console.log('aaa')
  const m = location.href.match(/^.+\/work\/detail\/([^/]+)$/);
  if(m) {
    // const key = m[1];
    const label = process.env.GATSBY_LANG === 'EN' ? 'Back to Project Summary' : 'プロジェクト概要へ戻る'
    const to = location.href.replace('work/detail', 'work');
    return text.replaceAll("[[parent]]", `<a href="${to}">${label}</a>`)
  } else {
    return text.replaceAll("[[parent]]", '')
  }
}

export function replaceBold(str: string) {
  return str.replace(/ \*\*(.+?)\*\* /g, '<span class="bold">$1</span>');
}
export function replaceItalic(str: string) {
  return str.replace(/ \*\*\*(.+?)\*\*\* /g, '<span class="italic">$1</span>');
}
